/**
 * Keyboard-accessible skip-to-content link (WCAG 2.4.1).
 * Visually hidden until focused, then appears at the top-left corner.
 */
export function SkipToContent({ target = "#main-content" }: { target?: string }) {
  return (
    <a
      href={target}
      className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:px-4 focus:py-2 focus:bg-brand-600 focus:text-white focus:rounded-md focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-2"
    >
      Skip to main content
    </a>
  );
}
